import { render } from "./HeroiconsOutlineShare.vue?vue&type=template&id=ffac21ec"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineShare.vue"]])

export default __exports__